@if (order$ | async; as data) {
<div class="order-confirmation-wrapper">
  @if (!hideRefNumEnabled) {
  <div class="ref-num">
    {{ 'orderConfirmation.referenceNumber' | cxTranslate : { orderCode: this.orderId } }}
  </div>
  } @if (showConformationText) {
  <div
    class="confirmation-text"
    [innerHtml]="'orderConfirmation.confirmationText' | cxTranslate : { email: data.user?.originalEmailId }"
  ></div>
  } @if (data.deliveryAddress) {
  <div class="delivery-wrapper">
    <div class="order-title">
      {{ 'orderConfirmation.deliveryDetails.title' | cxTranslate }}
    </div>
    <div class="delivery-for">
      <label>{{ 'orderConfirmation.deliveryDetails.deliveryFor' | cxTranslate }}</label>
      @if (data.deliveryAddress?.firstName && data.deliveryAddress?.lastName) {
      <div>
        {{ data.deliveryAddress?.title }} {{ data.deliveryAddress?.firstName }} {{ data.deliveryAddress?.lastName }}
      </div>
      } @else { @if (showCompanyName) {
      <div>
        {{ data?.deliveryAddress?.companyName }}
      </div>
      } } @if (data.deliveryAddress?.phone) {
      <div>{{ 'orderConfirmation.deliveryDetails.phoneNumber' | cxTranslate }} {{ data.deliveryAddress?.phone }}</div>
      } @else { @if (data.deliveryAddress?.cellphone) {
      <div>
        {{ 'orderConfirmation.deliveryDetails.phoneNumber' | cxTranslate }} {{ data.deliveryAddress?.cellphone }}
      </div>
      } }
    </div>
    <div class="delivery-addr">
      <label>{{ 'orderConfirmation.deliveryDetails.deliveryAddr' | cxTranslate }}</label>
      <div [innerHTML]="showAddress(data.deliveryAddress) | async"></div>
    </div>
  </div>
  } @if (data.paymentInfoDetails) {
  <div class="payment-wrapper">
    <div class="order-title">
      {{ 'orderConfirmation.paymentDetails.title' | cxTranslate }}
    </div>
    <div class="payment-details-wrapper">
      <div class="payment-method">
        <label>{{ 'orderConfirmation.paymentDetails.method' | cxTranslate }}</label>
        <div>
          {{ data.paymentInfoDetails?.paymentModeName }}
        </div>
      </div>
      <div class="payment-terms">
        <label>{{ 'orderConfirmation.paymentDetails.terms' | cxTranslate }}</label>
        <div>
          {{ data.paymentInfoDetails?.paymentTerms }}
        </div>
      </div>
      <div class="payment-addr">
        <label>{{ 'orderConfirmation.paymentDetails.billingAddr' | cxTranslate }}</label>
        <div [innerHTML]="showAddress(data.paymentInfoDetails?.billingAddress) | async"></div>
        @if (data.paymentInfoDetails?.billingAddress?.phone) {
        <div>
          {{ 'orderConfirmation.deliveryDetails.phoneNumber' | cxTranslate }}
          {{ data.paymentInfoDetails?.billingAddress?.phone }}
        </div>
        } @else { @if (data.paymentInfoDetails?.billingAddress?.cellphone) {
        <div>
          {{ 'orderConfirmation.deliveryDetails.phoneNumber' | cxTranslate }}
          {{ data.paymentInfoDetails?.billingAddress?.cellphone }}
        </div>
        } }
      </div>
    </div>
  </div>
  }
</div>
} @else {
<div class="results-spinner">
  <mat-spinner [diameter]="72"></mat-spinner>
</div>
}
